function AutoFilterLayout ( props ) {

    const { children } = props;

    return (
        <>
        { children }
        </>
    );

}

export default AutoFilterLayout;

